import React from "react";
import ProductPluSearch from "./ProductPluSearch";
import type { FilterProps } from "../../../viewmodels/qaReports/qaReportTypes";

export default function ProductReportFilter({ filters, setFilters, logout, disabled }: FilterProps) {
  return (
    <div className="grid grid-cols-6 gap-3">
      <ProductPluSearch
        value={filters.product}
        onChange={(product) => setFilters({ ...filters, product })}
        logout={logout}
        disabled={disabled}
      />
    </div>
  );
}
